import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * const { can, canAny, rule, isOwner } = useAccess();
 *   can('billing.export_history')
 *   canAny(['billing.create', 'billing.view_history'])
 *   rule('billing', 'maxDiscountLimit', 100)
 * Re-renders when access changes (branch switch, HQ / manager change).
 */
export default function useAccess() {
  const { user, hasPermission, constraint, accessReady } = useAuth();
  const can = useCallback((key) => {
    if (!key) return true;
    const [module, action = 'view'] = String(key).split('.');
    return hasPermission(module, action);
  }, [hasPermission]);
  const canAny = useCallback((keys = []) => (Array.isArray(keys) ? keys : [keys]).some(can), [can]);
  const canAll = useCallback((keys = []) => (Array.isArray(keys) ? keys : [keys]).every(can), [can]);
  const rule = useCallback((module, key, fallback) => constraint(module, key, fallback), [constraint]);
  return {
    can,
    canAny,
    canAll,
    rule,
    role: user?.role || null,
    isOwner: user?.role === 'SUPERADMIN',
    ready: Boolean(accessReady),
  };
}